import React, { forwardRef } from 'react';
import { useTheme } from '@rabex-kit/rabex-ui';

type IconColor = string;
type IconSize = string | number;

interface IconProps {
  color?: IconColor;
  size?: IconSize;
  className?: string;
  style?: React.CSSProperties;
  children: React.ReactElement<React.SVGProps<SVGSVGElement>>;
  onClick?: (event: React.MouseEvent<SVGSVGElement>) => void;
}

const Icon = forwardRef<SVGSVGElement, IconProps>(
  (
    { color, size = '1em', className = '', style = {}, onClick, children },
    ref
  ) => {
    const theme = useTheme();
    const iconColor = color || theme.palette.base[950] || 'rgba(22, 24, 31, 1)';

    const iconStyle: React.CSSProperties = {
      cursor: onClick && 'pointer',
      width: size,
      height: size,
      color: iconColor,
      ...style
    };

    return React.cloneElement(children, {
      style: { ...children.props.style, ...iconStyle },
      className: [children.props.className, className]
        .filter(Boolean)
        .join(' '),
      onClick
    });
  }
);

export default Icon;
